import React, { useEffect, useState } from "react";
import { useIntl } from "@umijs/max";
import dayjs from "@/utils/time";

const MenuFooterTime: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const intl = useIntl();
  // dayjs() from @/utils/time defaults to Beijing time
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(dayjs());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (collapsed) return null;

  return (
    <div
      style={{
        padding: "12px 16px",
        color: "rgba(0,0,0,0.45)",
        fontSize: "11px",
        borderTop: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          marginBottom: 4,
          display: "flex",
          justifyContent: "space-between",
          gap: 8,
        }}
      >
        <span style={{ whiteSpace: "nowrap" }}>
          {intl.formatMessage({ id: "pages.common.time.local" })}:
        </span>
        <span style={{ fontWeight: 500, fontFamily: "monospace" }}>
          {now.local().format("YYYY-MM-DD HH:mm:ss")}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
        <span style={{ whiteSpace: "nowrap" }}>
          {intl.formatMessage({ id: "pages.common.time.beijing" })}:
        </span>
        <span style={{ fontWeight: 500, fontFamily: "monospace" }}>
          {now.format("YYYY-MM-DD HH:mm:ss")}
        </span>
      </div>
    </div>
  );
};

export default MenuFooterTime;
